<ng-form #form="ngForm">
    <div class="_section m-b">
        <div class="p-a-6 bg-col-w">
            <div class="cursor-pointer flex flex-top"
                 (click)="select('login', true)">
                <i class="m-r-3 inline-flex icon-account2"
                   [style.top.px]="3"
                   style="font-size: 1.6em;"></i>
                <div>
                    <h5 class="s1 inline-block va-m">{{ 'Sign in' | translate }}</h5>
                    <p class="p1 m-t-2">{{ 'Checkout faster with saved details' | translate }}</p>
                </div>
            </div>

            <div class="hide-up-container">
                <div class="ng-hide ng-hide-animate"
                     [zippyHideUp]="expandableLoginId"
                     [zippyAnimationDuration]="350">
                    <div *ngIf="status === 'login'">
                        <ng-container [ngSwitch]="accountStatus">
                            <p class="p2 col-1 m-t-5">
                                {{'Your email' | translate}}
                            </p>

                            <input-wrap class="w-12 m-t">
                                <input class="input"
                                       type="email"
                                       validatePattern="email"
                                       autocomplete="email"
                                       name="email"
                                       [attr.placeholder]="'Email address'"
                                       [muiInput]="('Email address'| translate)"
                                       maxlength="80"
                                       [(ngModel)]="email"
                                       [ngModelOptions]="{updateOn: 'blur'}"
                                       required
                                       email
                                       #emailInput
                                       (keyup.enter)="emailInput.blur()">
                            </input-wrap>
                            <ng-container *ngSwitchCase="EAccountStatus.welcome">
                                <ng-container *ngTemplateOutlet="checkTpl"></ng-container>
                            </ng-container>
                            <ng-container *ngSwitchCase="EAccountStatus.newUser">
                                <ng-container *ngTemplateOutlet="checkTpl"></ng-container>
                            </ng-container>

                            <ng-container *ngSwitchCase="EAccountStatus.login">
                                <p class="p2 col-1 m-t-5">
                                    {{'Please enter your password' | translate}}
                                </p>

                                <!-- password input -->
                                <input-wrap class="w-12 m-t is-password">
                                    <view-password>
                                        <input class="input"
                                               type="password"
                                               name="password"
                                               [attr.placeholder]="'Enter password'"
                                               required
                                               [muiInput]="'Password'| translate"
                                               [(ngModel)]="data.password"
                                               (keyup.enter)="continue()">
                                    </view-password>
                                </input-wrap>

                                <!-- reset my password -->
                                <div class="m-t-5">
                                    <action class="button-inline p1"
                                            [status]="passwordStatus"
                                            (click)="resetPassword()"> {{ 'Forgot Password?' | translate }}</action>

                                    <result [status]="passwordStatus"
                                            [success]="'We\'ve sent you an email with a link to reset your password.'| translate">
                                    </result>
                                </div>

                                <ng-container *ngTemplateOutlet="continueTpl"></ng-container>
                            </ng-container>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="_section">
        <div class="p-a-6 bg-col-w">
            <div class="cursor-pointer flex flex-top"
                 (click)="select('guest', true)">
                <i class="m-r-3 inline-flex icon-lock"
                   [style.top.px]="3"
                   style="font-size: 1.4em;"></i>
                <div>
                    <h5 class="s1 inline-block va-m">{{ 'Guest checkout' | translate }}</h5>
                    <p class="p1 m-t-2">{{ 'You can create an account once you\'ve completed your order' | translate }}
                    </p>
                </div>
            </div>


            <div [zippyHideUp]="expandableGuestId"
                 [zippyAnimationDuration]="350">
                <div class="p-t"
                     *ngIf="status === 'guest'">

                    <p class="p2 col-1 m-t">
                        {{'Your details' | translate}}
                    </p>

                    <input-wrap class="w-12 m-t">
                        <input class="input"
                               type="email"
                               validatePattern="email"
                               autocomplete="email"
                               name="email"
                               [attr.placeholder]="'Email address'"
                               [muiInput]="('Email address'| translate)"
                               maxlength="80"
                               [(ngModel)]="email"
                               [ngModelOptions]="{updateOn: 'blur'}"
                               required
                               email
                               #emailInput
                               (blur)="detectChanges()"
                               (keyup.enter)="emailInput.blur()">
                    </input-wrap>
                    @if (isChecked()){
                    <!-- first name -->
                    <input-wrap class="m-t-3 block">
                        <input class="input"
                               type="text"
                               autocomplete="given-name"
                               name="firstname"
                               [muiInput]="('First name'| translate)"
                               validatePattern="name"
                               maxlength="100"
                               required
                               (blur)="detectChanges()"
                               [(ngModel)]="shippingData.firstname">
                    </input-wrap>

                    <!-- last name -->
                    <input-wrap class="m-t-3 m-b-5 block">
                        <input class="input"
                               type="text"
                               autocomplete="family-name"
                               name="lastname"
                               [muiInput]="('Last name'| translate)"
                               validatePattern="name"
                               maxlength="50"
                               required
                               (blur)="detectChanges()"
                               [(ngModel)]="shippingData.lastname">
                    </input-wrap>
                    }


                    <ng-container *ngTemplateOutlet="continueTpl"></ng-container>
                </div>
            </div>
        </div>
    </div>
</ng-form>

<!-- step for validation hack -->
<ng-form #stepForm="ngForm">
    <!-- dummy field for step validataion for step -->
    <input type="hidden"
           name="dummy"
           [(ngModel)]="dummy"
           required
           *ngIf="!isValid">
</ng-form>

<!-- Template for: submission button -->
<ng-template #continueTpl>
    <action class="w-12 m-t m-t-5-s button"
            [status]="continueStatus"
            (click)="continue()">
        {{ continueLabel | translate }}
    </action>

    <!-- result -->
    <result [status]="continueStatus"></result>
</ng-template>


<!-- Template for: submission button -->
<ng-template #checkTpl>
    <action class="w-12 m-t m-t-5-s button"
            [status]="checkStatus"
            (click)="check()">
        {{ 'Continue' | translate }}
    </action>

    <!-- result -->
    <result [status]="checkStatus"></result>
</ng-template>
